/**
 * REBAR COLOR PICKER v1.3.0
 * --------------------------------------------------------------------------
 * A lightweight, zero-dependency color picker component
 * * @requires rebar-picker.css
 * * @example
 * 
 * 1. HTML Implementation
 * <div id="picker1" class="rebar-color-picker" default="#ffffff"></div>
 * 
 * 2. Access or set color via JS
 * const color = document.getElementById('picker1').value;
 * document.getElementById('picker1').value = '#007BFF';
 * 
 * 3. Event Handling
 * document.getElementById('picker1').addEventListener('change', (e) => {
 *    console.log('New color:', e.target.value);
 * });
 * --------------------------------------------------------------------------
 */
class ColorPicker {
    constructor(element) {
        this.container = element;
        const defaultColor = element.getAttribute('default') || '#000000';

        this._value = defaultColor;
        this.setupValueProperty();
        this.init();
    }

    setupValueProperty() {
        Object.defineProperty(this.container, 'value', {
            get: () => this._value,
            set: (val) => {
                if (/^#[0-9A-F]{6}$/i.test(val)) {
                    this._value = val;
                    this.updateUI(val);
                }
            },
            configurable: true
        });
    }

    init() {
        // Pure structure - styling handled by external CSS
        this.container.innerHTML = `
            <div class="wrapper">
                <input type="color" class="native" value="${this._value}">
                <input type="text" class="hex-input" value="${this._value.toUpperCase()}" maxlength="7" spellcheck="false">
            </div>
        `;

        const native = this.container.querySelector('.native');
        const textInput = this.container.querySelector('.hex-input');

        // SYNC: Picker -> Text Input
        native.addEventListener('input', (e) => {
            const newColor = e.target.value.toUpperCase();
            this._value = newColor;
            textInput.value = newColor;
            this.container.dispatchEvent(new Event('change', { bubbles: true }));
        });

        // SYNC: Text Input -> Picker
        textInput.addEventListener('input', (e) => {
            let val = e.target.value;

            if (val.length > 0 && !val.startsWith('#')) {
                val = '#' + val;
                textInput.value = val;
            }

            if (/^#[0-9A-F]{6}$/i.test(val)) {
                this._value = val.toUpperCase();
                native.value = val;
                this.container.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        textInput.addEventListener('blur', () => {
            textInput.value = this._value;
        });
    }

    updateUI(color) {
        const native = this.container.querySelector('.native');
        const textInput = this.container.querySelector('.hex-input');
        if (native) native.value = color;
        if (textInput) textInput.value = color.toUpperCase();
    }
}

// Ensure the color picker class is available
window.ColorPicker = ColorPicker;

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.rebar-color-picker').forEach(div => new ColorPicker(div));
});